import "./LineHeightPicker.scss";
import classNames from "classnames";
import Button from "../../../Button/Button";

const lineHeightOptions = ["1", "1.25", "1.5", "1.75", "2"];

const LineHeightPicker = ({currentLineHeight, onClick}) => {
    return <>
        {
            lineHeightOptions.map((option, index) =>
            <Button
                key={index}
                className={classNames({active: currentLineHeight === option})}
                onClick={() => onClick(option)}
            >
                {option}
            </Button>)
        }
    </>
}

export default LineHeightPicker